import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import createDefaultEntitiesReducer from './DefaultEntitiesReducer';


export default combineReducers(Immutable.Map({
  users: createDefaultEntitiesReducer('users', true),
  accounts: createDefaultEntitiesReducer('accounts', true),
  bibs: createDefaultEntitiesReducer('bibs', true),
  borrowingHistory: createDefaultEntitiesReducer('borrowingHistory'),
  holds: createDefaultEntitiesReducer('holds'),
  checkouts: createDefaultEntitiesReducer('checkouts'),
  fines: createDefaultEntitiesReducer('fines', true),
  interlibraryLoans: createDefaultEntitiesReducer('interlibraryLoans', true),
  messages: createDefaultEntitiesReducer('messages'),
  shelves: createDefaultEntitiesReducer('shelves', true),
  sites: createDefaultEntitiesReducer('sites', true),
  optIn: createDefaultEntitiesReducer('optIn', true),
  libraries: createDefaultEntitiesReducer('libraries', true),
  featuredContent: createDefaultEntitiesReducer('featuredContent', true),
  systemMessages: createDefaultEntitiesReducer('systemMessages', true),
  ugc: createDefaultEntitiesReducer('ugc', true)
}));



// WEBPACK FOOTER //
// ./app/reducers/entities/index.js